import React, { useState, useEffect, useContext } from "react";
import { ContextBoard } from "../../context/ContextBoard";
import { useNavigate } from "react-router-dom";
import Select from "react-select";

import Footer from "../shared/Footer";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import config from "../../config";
import Swal from "sweetalert2";
import { label } from "framer-motion/client";

function EditSchool() {
  const navigate = useNavigate();
  const { secondaryAdminSchoolCode } = useContext(ContextBoard);
  const permissions = JSON.parse(sessionStorage.getItem("permissions") || "[]");
  const token = sessionStorage.getItem("secondaryAdminToken");
  const [loading, setLoading] = useState(true);

  const [previewMode, setPreviewMode] = useState(false);
  const isDisabled = previewMode;

  const [stateList, setStateList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [blockList, setBlockList] = useState([]);
  const [subDivisionList, setSubDivisionList] = useState([]);

  const [typeOfSchoolOptions, setTypeOfSchoolOptions] = useState([]);

  const [class9limit, setClass9limit] = useState("");
  const [class10limit, setClass10limit] = useState("");

  const [schoolInfo, setSchoolInfo] = useState({
    schooL_CODE: "",
    udisE_CODE: "",
    schooL_NAME: "",
    sC_ADDRESS: "",
    // typE_OF_SCHOOL: "",
    /* administration: "",
        telephonE_NO: "", */
    piN_CODE: "",
    area: "",
    posT_OFFICE: "",
    nearesT_RAILWAY_STATION: "",
    challaN_LIMIT: "",
    challaN_LIMIT_CL_10: "",
    heaD_NAME: "",
    heaD_MOBILE_NO: "",
    emaiL_ADDRESS: "",
    asstistencE_TEACHER_CONTACT: "",
  });

  const [selectedState, setSelectedState] = useState("");
  const [typeofschool, setTypeofschool] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedBlock, setSelectedBlock] = useState("");
  const [selectedSubDivision, setSelectedSubDivision] = useState("");

  const [errors, setErrors] = useState({});
  useEffect(() => {
    if (!permissions[1]?.caN_VIEW) {
      navigate("/secondary-admin-dashboard");
    }
  }, [permissions, navigate]);
  const toOptions = (list, valueKey, labelKey) =>
    list.map((item) => ({
      value: item[valueKey],
      label: item[labelKey],
    }));

  const fetchSchoolDetails = async () => {
    if (!secondaryAdminSchoolCode) {
      navigate("/secondary-admin-school-list");
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(
        `${config.API_BASE_URL}/PageLoadSecondaryDataSchool_CL9`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ schooL_CODE: secondaryAdminSchoolCode }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        const groupData = data.data;
        const school = groupData.schoolDetails[0] || "";
        setStateList(groupData.stateList);
        setDistrictList(groupData.districtList);
        setBlockList(groupData.blockList);
        setSubDivisionList(groupData.divisionlist);
        setSchoolInfo(school);

        setTypeOfSchoolOptions(
          groupData.schoolType.map((t) => ({
            value: t.typE_OF_SCHOOL,
            label: t.typE_OF_SCHOOL,
          }))
        );

        setClass9limit(groupData.schoolDetails[0]?.challaN_LIMIT || "");
        setClass10limit(groupData.schoolDetails[0]?.challaN_LIMIT_CL_10 || "");

        setTypeofschool({
          value: school.typE_OF_SCHOOL,
          label:
            groupData.schoolType.find(
              (s) => s.typE_OF_SCHOOL === school.typE_OF_SCHOOL
            )?.typE_OF_SCHOOL || "",
        });

        setSelectedState({
          value: school.state,
          label:
            groupData.stateList.find((s) => s.statE_CODE === school.state)
              ?.statE_NAME || "",
        });

        setSelectedDistrict({
          value: school.districT_CODE,
          label:
            groupData.districtList.find(
              (d) => d.districT_CODE === school.districT_CODE
            )?.district || "",
        });

        setSelectedBlock({
          value: school.blocK_ID,
          label:
            groupData.blockList.find((b) => b.blocK_ID === school.blocK_ID)
              ?.blocK_NAME || "",
        });

        setSelectedSubDivision({
          value: school.suB_DIVISION,
          label:
            groupData.divisionlist.find(
              (s) => s.divisioN_ID === school.suB_DIVISION
            )?.divisioN_NAME || "",
        });
      } else {
        Swal.fire("Error", "Unable to fetch school information", "error").then(
          (result) => {
            if (result.isConfirmed) {
              navigate("/secondary-admin-school-list");
            }
          }
        );
      }
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Something went wrong", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!token) {
      navigate("/secondary-admin");
    } else {
      fetchSchoolDetails();
    }
  }, [secondaryAdminSchoolCode]);

  const filteredDistricts = selectedState
    ? districtList.filter((d) => d.statE_CODE === selectedState.value)
    : [];
  const filteredBlocks = selectedDistrict
    ? blockList.filter((b) => b.disT_CODE === selectedDistrict.value)
    : [];
  const filteredSubDivisions = selectedDistrict
    ? subDivisionList.filter((s) => s.district === selectedDistrict.value)
    : [];

  const handleSelectChange = (level, value) => {
    switch (level) {
      case "state":
        setSelectedState(value);
        setSelectedDistrict("");
        setSelectedBlock("");
        setSelectedSubDivision("");
        break;
      case "district":
        setSelectedDistrict(value);
        setSelectedBlock("");
        setSelectedSubDivision("");
        break;
      case "block":
        setSelectedBlock(value);
        break;
      case "subdivision":
        setSelectedSubDivision(value);
        break;
      default:
        break;
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let newValue = value;

    if (/[|]/.test(newValue)) return;
    if (/\s{2,}/.test(newValue)) return;

    if (name === "schooL_NAME" || name === "sC_ADDRESS") {
      newValue = newValue.toUpperCase();
    }

    if (
      name === "typE_OF_SCHOOL" ||
      /* name === "administration" || */ name === "heaD_NAME"
    ) {
      // Allow letters and spaces only
      if (/[^a-zA-Z\s]/.test(value)) return;
      newValue = newValue.toUpperCase();
    }

    if (
      name === "telephonE_NO" ||
      name === "piN_CODE" ||
      name === "heaD_MOBILE_NO" ||
      name === "asstistencE_TEACHER_CONTACT" ||
      name === "challaN_LIMIT" ||
      name === "challaN_LIMIT_CL_10" ||
      name === "admissioN_COUNT" ||
      name === "udisE_CODE"
    ) {
      // Allow only digits
      if (/[^0-9]/.test(value)) return;
      if (
        (name === "telephonE_NO" ||
          name === "heaD_MOBILE_NO" ||
          name === "asstistencE_TEACHER_CONTACT") &&
        value.length > 10
      ) {
        return;
      }
      if (name === "piN_CODE" && newValue.length > 6) {
        return;
      }
      if (name === "emaiL_ADDRESS") {
        newValue = newValue.toLowerCase();
      }
      if (errors[name]) {
        setErrors((prev) => ({ ...prev, [name]: "" }));
      }
    }

    if (name === "posT_OFFICE" || name === "nearesT_RAILWAY_STATION") {
      // Allow letters, digits, and spaces only
      if (/[^a-zA-Z0-9\s]/.test(value)) return;
      newValue = newValue.toUpperCase();
    }

    setSchoolInfo({ ...schoolInfo, [name]: newValue });
  };

  const handlePreview = () => {
    const newErrors = {};
    const trimmed = (val) => String(val || "").trim();

    setLoading(true);

    setTimeout(() => {
      // String fields
      if (!trimmed(schoolInfo.schooL_NAME))
        newErrors.schooL_NAME = "School name is required.";
      if (!trimmed(schoolInfo.sC_ADDRESS))
        newErrors.sC_ADDRESS = "School address is required.";

      // React Select field for Type of School
      // if (!typeofschool?.value?.trim())
      //   newErrors.typE_OF_SCHOOL = "Type of school is required.";

      // Dropdown selections
      if (!selectedState) newErrors.state = "State is required.";
      if (!selectedDistrict) newErrors.districtcode = "District is required.";
      if (!selectedBlock) newErrors.blocK_NAME = "Block is required.";
      // if (!selectedSubDivision) newErrors.suB_DIVISION = "Subdivision is required.";
      if (!schoolInfo.udisE_CODE)
        newErrors.udisE_CODE = "UDISE Code is required";
      // Numbers or strings
      if (!trimmed(schoolInfo.challaN_LIMIT))
        newErrors.challaN_LIMIT =
          "Allowed Number of Challan Generation for class 9 is required.";
      if (!trimmed(schoolInfo.challaN_LIMIT_CL_10))
        newErrors.challaN_LIMIT_CL_10 =
          "Allowed Number of Challan Generation for class 10 is required.";

      // Other string validations
      if (!trimmed(schoolInfo.heaD_MOBILE_NO)) {
        newErrors.heaD_MOBILE_NO = "Principal mobile no is required.";
      } else if (schoolInfo.heaD_MOBILE_NO.length !== 10) {
        newErrors.heaD_MOBILE_NO = "Mobile no must be 10 digit";
      }
      if (
        schoolInfo.asstistencE_TEACHER_CONTACT &&
        schoolInfo.asstistencE_TEACHER_CONTACT.length
      ) {
        newErrors.asstistencE_TEACHER_CONTACT = "Mobile no must be 10 digit";
      }
      if (!trimmed(schoolInfo.emaiL_ADDRESS))
        newErrors.emaiL_ADDRESS = "Principal email is required.";

      setErrors(newErrors);
      setLoading(false);

      // If no errors → enable preview
      if (Object.keys(newErrors).length === 0) {
        setPreviewMode(true);
      }
    }, 500);
  };

  const handleEdit = () => {
    setPreviewMode(false);
  };

  const handleSubmit = async () => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to save the changes?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Save it",
      cancelButtonText: "Cancel",
    });

    if (confirm.isConfirmed) {
      setLoading(true);
      const payload = {
        UDISE_CODE: schoolInfo.udisE_CODE || "",
        ADMISSION_COUNT: schoolInfo.admissioN_COUNT || "",
        schooL_CODE: schoolInfo.schooL_CODE || "",
        schooL_NAME: schoolInfo.schooL_NAME || "",
        suB_DIVISION: selectedSubDivision?.value || "",
        sC_ADDRESS: schoolInfo.sC_ADDRESS || "",
        typE_OF_SCHOOL: typeofschool.value || "",
        state: selectedState?.value || "",
        district: selectedDistrict?.value || "",
        blocK_NAME: selectedBlock?.value || "",
        piN_CODE: schoolInfo.piN_CODE || "",
        area: schoolInfo.area || "",
        posT_OFFICE: schoolInfo.posT_OFFICE || "",
        nearesT_RAILWAY_STATION: schoolInfo.nearesT_RAILWAY_STATION || "",
        challaN_LIMIT: String(schoolInfo.challaN_LIMIT) || "",
        challaN_LIMIT_CL_10: String(schoolInfo.challaN_LIMIT_CL_10) || "",
        telephonE_NO: /* schoolInfo.telephonE_NO */ "",
        heaD_MOBILE_NO: schoolInfo.heaD_MOBILE_NO || "",
        emaiL_ADDRESS: schoolInfo.emaiL_ADDRESS || "",
        asstistencE_TEACHER_CONTACT:
          schoolInfo.asstistencE_TEACHER_CONTACT || "",
        administration: /* schoolInfo.administration */ "",
        heaD_NAME: schoolInfo.heaD_NAME,
        UPDATE_BY: sessionStorage.getItem("schoolCode") || "",
      };

      try {
        const response = await fetch(
          `${config.API_BASE_URL}/UpdateSchoolDataSecondary_CL9`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(payload),
          }
        );

        const result = await response.json();

        if (response.ok && result.status === 200) {
          Swal.fire(
            "Success",
            "School data updated successfully",
            "success"
          ).then(() => {
            navigate("/secondary-admin-school-list");
          });
        } else {
          Swal.fire(
            "warning",
            result.message || "Failed to update school data",
            "warning"
          );
        }
      } catch (err) {
        console.error(err);
        Swal.fire("Error", "Something went wrong during submission", "error");
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <div className="container-scroller">
      {loading && (
        <div className="custom-loader-container">
          <div className="custom-loader"></div>
        </div>
      )}
      <Navbar />
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="row">
              <div className="col-md-12 mb-3">
                <section className="content-header">
                  <h1>
                    <i className="fa fa-university" />
                    &nbsp;Edit School
                  </h1>
                  <ol className="breadcrumb">
                    <li>
                      <a
                        onClick={() => navigate("/secondary-admin-dashboard")}
                        style={{ cursor: "pointer" }}
                      >
                        <i
                          className="fa fa-tachometer"
                          style={{ marginRight: "5px" }}
                        ></i>{" "}
                        Home
                      </a>
                    </li>
                    <li className="active">Secondary Admin Edit School</li>
                  </ol>
                </section>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12 mb-4 stretch-card">
                <div className="card">
                  <div className="card-header">
                    <h4 className="mb-0 p-2">School Details</h4>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      {/* Left side: School Info (col-md-9) */}
                      <div className="col-md-9">
                        <div className="row">
                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>
                                UDISE Code{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                className={`form-control form-control-sm ${
                                  errors.udisE_CODE ? "is-invalid" : ""
                                }`}
                                name="udisE_CODE"
                                value={schoolInfo.udisE_CODE || ""}
                                inputMode="numeric"
                                pattern="[0-9]*"
                                onChange={handleInputChange}
                                disabled={isDisabled}
                                maxLength={15}
                              />
                              {errors.udisE_CODE && (
                                <div className="text-danger mt-1 small">
                                  {errors.udisE_CODE}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group mb-3">
                              <label>
                                Name of School{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                name="schooL_NAME"
                                className={`form-control form-control-sm ${
                                  errors.schooL_NAME ? "is-invalid" : ""
                                }`}
                                value={schoolInfo.schooL_NAME || ""}
                                onChange={handleInputChange}
                                disabled={isDisabled}
                                maxLength={150}
                              />
                              {errors.schooL_NAME && (
                                <div className="text-danger mt-1 small">
                                  {errors.schooL_NAME}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>Type of School</label>
                              <Select
                                value={typeofschool}
                                onChange={(selected) => {
                                  setTypeofschool(selected);
                                  setSchoolInfo((prev) => ({
                                    ...prev,
                                    typE_OF_SCHOOL: selected?.value || "",
                                  }));
                                }}
                                options={typeOfSchoolOptions}
                                isDisabled={isDisabled}
                                classNamePrefix="react-select"
                                placeholder="Select Type"
                              />
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>School Code</label>
                              <input
                                type="text"
                                className={`form-control form-control-sm ${
                                  errors.schooL_CODE ? "is-invalid" : ""
                                }`}
                                value={schoolInfo.schooL_CODE || ""}
                                disabled
                              />
                              {errors.schooL_CODE && (
                                <div className="text-danger mt-1 small">
                                  {errors.schooL_CODE}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group mb-3">
                              <label>
                                School Address{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                name="sC_ADDRESS"
                                className={`form-control form-control-sm ${
                                  errors.sC_ADDRESS ? "is-invalid" : ""
                                }`}
                                value={schoolInfo.sC_ADDRESS || ""}
                                onChange={handleInputChange}
                                disabled={isDisabled}
                                maxLength={150}
                              />
                              {errors.sC_ADDRESS && (
                                <div className="text-danger mt-1 small">
                                  {errors.sC_ADDRESS}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>
                                State <span className="text-danger">*</span>
                              </label>
                              <Select
                                options={toOptions(
                                  stateList,
                                  "statE_CODE",
                                  "statE_NAME"
                                )}
                                value={selectedState}
                                onChange={(val) =>
                                  handleSelectChange("state", val)
                                }
                                placeholder="Select State"
                                isDisabled={true}
                                className={errors.state ? "is-invalid" : ""}
                              />
                              {errors.state && (
                                <div className="text-danger mt-1 small">
                                  {errors.state}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>
                                District <span className="text-danger">*</span>
                              </label>
                              <Select
                                options={toOptions(
                                  filteredDistricts,
                                  "districT_CODE",
                                  "district"
                                )}
                                value={selectedDistrict}
                                onChange={(val) =>
                                  handleSelectChange("district", val)
                                }
                                isDisabled={true}
                                placeholder="Select District"
                                className={
                                  errors.districtcode ? "is-invalid" : ""
                                }
                              />
                              {errors.districtcode && (
                                <div className="text-danger mt-1 small">
                                  {errors.districtcode}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>
                                Block <span className="text-danger">*</span>
                              </label>
                              <Select
                                options={toOptions(
                                  filteredBlocks,
                                  "blocK_ID",
                                  "blocK_NAME"
                                )}
                                value={selectedBlock}
                                onChange={(val) =>
                                  handleSelectChange("block", val)
                                }
                                isDisabled={!selectedDistrict || isDisabled}
                                placeholder="Select Block"
                                className={
                                  errors.blocK_NAME ? "is-invalid" : ""
                                }
                              />
                              {errors.blocK_NAME && (
                                <div className="text-danger mt-1 small">
                                  {errors.blocK_NAME}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>Sub Division </label>
                              <Select
                                options={toOptions(
                                  filteredSubDivisions,
                                  "divisioN_ID",
                                  "divisioN_NAME"
                                )}
                                value={selectedSubDivision}
                                onChange={(val) =>
                                  handleSelectChange("subdivision", val)
                                }
                                isDisabled={!selectedDistrict || isDisabled}
                                placeholder="Select Subdivision"
                                className={
                                  errors.suB_DIVISION ? "is-invalid" : ""
                                }
                              />
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>Pin Code</label>
                              <input
                                type="text"
                                name="piN_CODE"
                                className={`form-control form-control-sm ${
                                  errors.piN_CODE ? "is-invalid" : ""
                                }`}
                                inputMode="numeric"
                                pattern="[0-9]*"
                                value={schoolInfo.piN_CODE || ""}
                                onChange={handleInputChange}
                                disabled={isDisabled}
                                maxLength={6}
                              />
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>Area</label>
                              <select
                                name="area"
                                className={`form-control form-select ${
                                  errors.area ? "is-invalid" : ""
                                }`}
                                value={schoolInfo.area || ""}
                                onChange={handleInputChange}
                                disabled={isDisabled}
                              >
                                <option value="">Select</option>
                                <option value="RURAL">Rural</option>
                                <option value="URBAN">Urban</option>
                              </select>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>Post Office</label>
                              <input
                                type="text"
                                name="posT_OFFICE"
                                className={`form-control form-control-sm ${
                                  errors.posT_OFFICE ? "is-invalid" : ""
                                }`}
                                value={schoolInfo.posT_OFFICE || ""}
                                onChange={handleInputChange}
                                disabled={isDisabled}
                                maxLength={50}
                              />
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>Nearest Railway Station </label>
                              <input
                                type="text"
                                name="nearesT_RAILWAY_STATION"
                                className={`form-control form-control-sm ${
                                  errors.nearesT_RAILWAY_STATION
                                    ? "is-invalid"
                                    : ""
                                }`}
                                value={schoolInfo.nearesT_RAILWAY_STATION || ""}
                                onChange={handleInputChange}
                                disabled={isDisabled}
                                maxLength={50}
                              />
                              {errors.nearesT_RAILWAY_STATION && (
                                <div className="text-danger mt-1 small">
                                  {errors.nearesT_RAILWAY_STATION}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>
                                Allowed Number of Challan Generation for class 9
                                <span className="text-danger">*</span>
                              </label>

                              <div className="d-flex align-items-center">
                                <button
                                  type="button"
                                  className="btn btn-danger btn-sm"
                                  onClick={() => {
                                    const minValue = class9limit;
                                    if (
                                      (parseInt(schoolInfo.challaN_LIMIT) ||
                                        0) > minValue
                                    ) {
                                      handleInputChange({
                                        target: {
                                          name: "challaN_LIMIT",
                                          value:
                                            (parseInt(
                                              schoolInfo.challaN_LIMIT
                                            ) || 0) - 1,
                                        },
                                      });
                                    }
                                  }}
                                  disabled={isDisabled}
                                >
                                  −
                                </button>
                                <input
                                  type="number"
                                  name="challaN_LIMIT"
                                  className={`form-control form-control-sm mx-2 text-center ${
                                    errors.challaN_LIMIT ? "is-invalid" : ""
                                  }`}
                                  value={schoolInfo.challaN_LIMIT || ""}
                                  readOnly
                                  disabled={isDisabled}
                                  min={class9limit}
                                />
                                <button
                                  type="button"
                                  className="btn btn-success btn-sm"
                                  onClick={() => {
                                    handleInputChange({
                                      target: {
                                        name: "challaN_LIMIT",
                                        value:
                                          (parseInt(schoolInfo.challaN_LIMIT) ||
                                            0) + 1,
                                      },
                                    });
                                  }}
                                  disabled={isDisabled}
                                >
                                  +
                                </button>
                              </div>

                              {errors.challaN_LIMIT && (
                                <div className="text-danger mt-1 small">
                                  {errors.challaN_LIMIT}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>
                                Allowed Number of Challan Generation for class
                                10
                                <span className="text-danger">*</span>
                              </label>

                              <div className="d-flex align-items-center">
                                {/* Minus Button */}
                                <button
                                  type="button"
                                  className="btn btn-danger btn-sm"
                                  onClick={() => {
                                    const minValue = class10limit; // define this variable like class9limit
                                    if (
                                      (parseInt(
                                        schoolInfo.challaN_LIMIT_CL_10
                                      ) || 0) > minValue
                                    ) {
                                      handleInputChange({
                                        target: {
                                          name: "challaN_LIMIT_CL_10",
                                          value:
                                            (parseInt(
                                              schoolInfo.challaN_LIMIT_CL_10
                                            ) || 0) - 1,
                                        },
                                      });
                                    }
                                  }}
                                  disabled={isDisabled}
                                >
                                  −
                                </button>

                                {/* Number Input */}
                                <input
                                  type="number"
                                  name="challaN_LIMIT_CL_10"
                                  className={`form-control form-control-sm mx-2 text-center ${
                                    errors.challaN_LIMIT_CL_10
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                  value={schoolInfo.challaN_LIMIT_CL_10 || ""}
                                  readOnly
                                  disabled={isDisabled}
                                  min={class10limit}
                                />

                                {/* Plus Button */}
                                <button
                                  type="button"
                                  className="btn btn-success btn-sm"
                                  onClick={() => {
                                    handleInputChange({
                                      target: {
                                        name: "challaN_LIMIT_CL_10",
                                        value:
                                          (parseInt(
                                            schoolInfo.challaN_LIMIT_CL_10
                                          ) || 0) + 1,
                                      },
                                    });
                                  }}
                                  disabled={isDisabled}
                                >
                                  +
                                </button>
                              </div>

                              {errors.challaN_LIMIT_CL_10 && (
                                <div className="text-danger mt-1 small">
                                  {errors.challaN_LIMIT_CL_10}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Right side: Principal Info (col-md-3) */}
                      <div
                        className="col-md-3"
                        style={{ borderLeft: "1px solid gray" }}
                      >
                        <div className="form-group mb-3">
                          <label>Principal Name </label>
                          <input
                            type="text"
                            name="heaD_NAME"
                            className={`form-control form-control-sm ${
                              errors.heaD_NAME ? "is-invalid" : ""
                            }`}
                            value={schoolInfo.heaD_NAME || ""}
                            onChange={handleInputChange}
                            disabled={isDisabled}
                            maxLength={50}
                          />
                          {errors.heaD_NAME && (
                            <div className="text-danger mt-1 small">
                              {errors.heaD_NAME}
                            </div>
                          )}
                        </div>

                        <div className="form-group mb-3">
                          <label>
                            Principal Mobile No{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            name="heaD_MOBILE_NO"
                            className={`form-control form-control-sm ${
                              errors.heaD_MOBILE_NO ? "is-invalid" : ""
                            }`}
                            inputMode="numeric"
                            pattern="[0-9]*"
                            value={schoolInfo.heaD_MOBILE_NO || ""}
                            onChange={handleInputChange}
                            disabled={isDisabled}
                            maxLength={10}
                          />
                          {errors.heaD_MOBILE_NO && (
                            <div className="text-danger mt-1 small">
                              {errors.heaD_MOBILE_NO}
                            </div>
                          )}
                        </div>

                        <div className="form-group mb-3">
                          <label>
                            Principal Email Address{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="email"
                            name="emaiL_ADDRESS"
                            className={`form-control form-control-sm ${
                              errors.emaiL_ADDRESS ? "is-invalid" : ""
                            }`}
                            value={schoolInfo.emaiL_ADDRESS || ""}
                            onChange={handleInputChange}
                            disabled={isDisabled}
                            maxLength={100}
                          />
                          {errors.emaiL_ADDRESS && (
                            <div className="text-danger mt-1 small">
                              {errors.emaiL_ADDRESS}
                            </div>
                          )}
                        </div>

                        <div className="form-group mb-3">
                          <label>Assistant Teacher Mobile No</label>
                          <input
                            type="text"
                            name="asstistencE_TEACHER_CONTACT"
                            className={`form-control form-control-sm ${
                              errors.asstistencE_TEACHER_CONTACT
                                ? "is-invalid"
                                : ""
                            }`}
                            inputMode="numeric"
                            pattern="[0-9]*"
                            value={schoolInfo.asstistencE_TEACHER_CONTACT || ""}
                            onChange={handleInputChange}
                            disabled={isDisabled}
                            maxLength={10}
                          />
                          {errors.asstistencE_TEACHER_CONTACT && (
                            <div className="text-danger mt-1 small">
                              {errors.asstistencE_TEACHER_CONTACT}
                            </div>
                          )}
                        </div>
                        <div className="form-group mb-3">
                          <label>Admission Count Class 9</label>
                          <input
                            type="text"
                            name="admissioN_COUNT"
                            className="form-control form-control-sm"
                            inputMode="numeric"
                            pattern="[0-9]*"
                            value={schoolInfo.admissioN_COUNT || ""}
                            onChange={handleInputChange}
                            disabled={isDisabled}
                            maxLength={3}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Action buttons */}
              <div className="col-md-12 stretch-card">
                <div className="card">
                  <div className="card-body">
                    {previewMode ? (
                      <>
                        <button
                          className="btn btn-primary me-2"
                          style={{ float: "right" }}
                          onClick={handleSubmit}
                        >
                          <i className="fa fa-save" /> Save
                        </button>
                        <button
                          className="btn btn-info me-2"
                          style={{ float: "right" }}
                          onClick={handleEdit}
                        >
                          <i className="fa fa-edit" /> Edit
                        </button>
                      </>
                    ) : (
                      <button
                        className="btn btn-secondary me-2"
                        style={{ float: "right" }}
                        onClick={handlePreview}
                      >
                        <i className="fa fa-eye" /> Preview
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default EditSchool;
